import * as React from 'react';
import { connect } from 'react-redux';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { GlobalPrivateState, } from 'src/api';
import { RequestApiResult, requestAPIActions } from 'loopback-react-request';

import './TroughAdd.scss';

export interface TroughAddProps {
  configuration: RequestApiResult<ConfigurationModel>;
  dispatch: any;
  troughId: string;
}

export class TroughAddPartial extends React.Component<TroughAddProps> {
  
  constructor(props: TroughAddProps) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }
  
  public render() {
    return (
      <div className="partial-trough-add">
        <button 
          className="trough-icon trough-icon-add"
          onClick={this.handleClick}
          disabled={this.isSelected}
        >
          <span className="add" />
        </button>
      </div>
    );
  }

  private get isSelected(): boolean {
    const { configuration, troughId } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.troughId === troughId ? true : false;
  }

  private get quantity(): number | null | undefined {
    const { configuration } = this.props;
    return configuration && 
      configuration.result && 
      configuration.result.selectedTrough && 
      configuration.result.selectedTrough.qty;
  }

  private get configurationId(): string | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result && configuration.result.id;
  }
  
  private handleClick(event: React.MouseEvent) {
    const { troughId } = this.props;
    if (!this.isSelected && this.configurationId) {
      this.props.dispatch(requestAPIActions.load(
        'configuration',
        { 
          url: `/Configurations/${this.configurationId}`,
          options: {
            method: 'PATCH',
            data: {
              troughId: troughId,
              selectedTrough: {
                qty: this.quantity || 1
              }
            }
          },
        },
        true
      ));
    }    
  }
}

export const TroughAdd = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
}))(TroughAddPartial);

export default TroughAdd;
